module.exports = require("@babel/runtime-corejs2/regenerator");